import ApiService from './api'

const DashboardService = {

    /** Fetches FAQ performance KPIs for the dashboard; empty object on error. */
    fetch: async function(botId: string): Promise<any> {
        try {
            const response = await ApiService.get('/bot/faq/performancekpis/' + botId);
            return response.data;
        } catch (error) {
            return {};
        }
    },

    /** Fetches the top answers ranking for the dashboard; empty object on error. */
    topAnswers: async function(botId: string): Promise<any> {
        try {
            const response = await ApiService.get('/schaltzentrale/dashboard/topanswers/' + botId);
            return response.data;
        } catch (error) {
            return {};
        }
    }
}

export default DashboardService

export { DashboardService }
